import { useContext } from "react";
import MainContext from "../providers/Main";
const useConfig = () => {
    const config = useContext(MainContext);
    return Object.assign(Object.assign({}, config), { toAbsoluteUrl: (pathname) => config.publicUrl + pathname });
};
export default useConfig;
